// export const URL = 'https://api.competitividad21.com/';
export const URL = 'https://stage-sie-p1702.competitividad21.com/';
// export const URL = 'https://tester-sie-p1702.competitividad21.com/';